import { createSlice } from "@reduxjs/toolkit";
import { loginUserSelectInstitution, logoutUser } from "../actions/account";

const initialState = {
  tableFilters: {},
  columnFilters: [],
  selectedAllClients: false,
  selectedClientsIds: [],
  unselectedClientsIds: [],
  tabValue: "",
  rowsPerPage: 20
};

const clientUISlice = createSlice({
  name: "clientUI",
  initialState,
  reducers: {
    "account/logoutUser": (state) => initialState,
    storeClientFilters(state, action) {
      state.tableFilters = action.payload;
    },
    storeClientColumnFilters(state, action) {
      state.columnFilters = action.payload;
    },
    setSelectedAllClients(state, action) {
      state.selectedAllClients = action.payload;
    },
    setSelectedClientsIds(state, action) {
      state.selectedClientsIds = action.payload;
    },
    setUnselectedClientsIds(state, action) {
      state.unselectedClientsIds = action.payload;
    },
    setTabValue(state, action) {
      state.tabValue = action.payload
    },
    setRowsPerPage(state, action) {
      state.rowsPerPage = action.payload
    }
  },
  extraReducers: {
    [logoutUser.fulfilled]: (state) => {
      return initialState;
    },
    [logoutUser.rejected]: (state) => {
      return initialState;
    },
    [loginUserSelectInstitution.fulfilled]: (state) => {
      return initialState;
    },
    [loginUserSelectInstitution.rejected]: (state) => {
      return initialState;
    },
  },
});

export const getTableFilters = (state) => state.clientUI.tableFilters;
export const getColumnFilters = (state) => state.clientUI.columnFilters;
export const getSelectedAllClients = (state) => state.clientUI.selectedAllClients;
export const getSelectedClientsIds = (state) => state.clientUI.selectedClientsIds;
export const getUnselectedClientsIds = (state) => state.clientUI.unselectedClientsIds;
export const getTabValue = (state) => state.clientUI.tabValue;
export const getRowsPerPage = (state) => state.clientUI.rowsPerPage;

export const { storeClientFilters, storeClientColumnFilters, setSelectedAllClients, setSelectedClientsIds, setUnselectedClientsIds, setTabValue, setRowsPerPage } =
  clientUISlice.actions;

export default clientUISlice;
